import { useOrganizationPreferences } from "hooks";

const useDatalabsBaseUrl = (): string => {
  const { hasPublisherFeatures, hasDataPartnerFeatures, hasDatalabFeatures } =
    useOrganizationPreferences();
  if (hasPublisherFeatures) {
    return "/publisherportal/datalabs";
  }
  if (hasDataPartnerFeatures) {
    return "/data-partner-portal/datalabs";
  }
  if (hasDatalabFeatures) {
    return "/datalabs";
  }
  return "/not-found";
};

export default useDatalabsBaseUrl;
